module.exports = __webpack_public_path__ + "img/linkinsta.0f0baf40.svg";